import { Callout, DialogActions, DialogContent, DialogTitle, LinearProgress } from "@octopusdeploy/design-system-components";
import cn from "classnames";
import * as React from "react";
import type { BusyState } from "~/components/BusyFromPromise/BusyFromPromise";
import BusyFromPromise from "~/components/BusyFromPromise/BusyFromPromise";
import type { Errors } from "~/components/DataBaseComponent/Errors";
import { getErrorsFromError, isErrors } from "~/components/DataBaseComponent/Errors";
import KeyboardHandler, { Key } from "../KeyboardHandler/KeyboardHandler";
import styles from "./style.module.less";
export interface DialogLayoutDispatchProps {
    close: () => void;
}
export interface DialogLayoutCommonProps {
    title: string | React.ReactNode;
    titleIcon?: React.ReactNode;
    extraHeaderContent?: (alignmentClassName: string) => React.ReactNode;
    additionalActions?: React.ReactNode;
    secondaryActions?: React.ReactNode;
    errors?: Errors | Error[] | null;
    busy?: BusyState | null;
    headerClassName?: string;
    dialogClassName?: string;
    children?: React.ReactNode;
}
interface DialogLayoutProps extends DialogLayoutCommonProps {
    actions: React.ReactNode;
    closeDialog(): void;
}
interface DialogLayoutState {
    dialogResizeKey: string;
}
/**
 * @deprecated Use workflows instead. See https://docs.octopushq.com/docs/frontend/workflows
 */
export class DialogLayout extends React.Component<DialogLayoutProps, DialogLayoutState> {
    constructor(props: DialogLayoutProps) {
        super(props);
        this.state = {
            dialogResizeKey: new Date().getDate().toString(),
        };
    }
    render() {
        const keyboardRegistrations = [{ key: Key.Esc, onKeyPressed: this.onEscKeyPressed }];
        const errors = this.props.errors;
        const convertedErrors = errors === undefined || errors === null ? undefined : isErrors(errors) ? [errors] : errors.map(getErrorsFromError);
        return (<KeyboardHandler key={this.state.dialogResizeKey} registrations={keyboardRegistrations} className={cn(styles.dialogLayout, this.props.dialogClassName)}>
                <DialogTitle className={cn(this.props.headerClassName ? this.props.headerClassName : styles.headerContainer)}>
                    <BusyFromPromise promise={this.props.busy}>{(busy: boolean) => <LinearProgress variant={"indeterminate"} show={busy}/>}</BusyFromPromise>
                    <div className={styles.title}>
                        {React.isValidElement(this.props.title) ? (this.props.title) : (<>
                                {this.props.titleIcon && <div className={styles.titleIcon}>{this.props.titleIcon}</div>}
                                {this.props.title}
                            </>)}
                    </div>
                </DialogTitle>
                <DialogContent className={styles.body}>
                    {this.props.extraHeaderContent && this.props.extraHeaderContent(styles.headerContentAlignment)}
                    {convertedErrors &&
                convertedErrors.map((error, index) => (<Callout key={index} type={"danger"} title={error.message}>
                                {/* ensure a space appears between error messages */}
                                {error.errors.join(" ")}
                            </Callout>))}
                    {this.props.children}
                </DialogContent>
                <DialogActions className={styles.actions}>
                    <div key="additional" className={styles.secondaryActions}>
                        {this.props.additionalActions}
                    </div>
                    <div key="primary" className={styles.primaryActions}>
                        {this.props.actions}
                    </div>
                </DialogActions>
            </KeyboardHandler>);
    }
    onEscKeyPressed = () => {
        if (this.props.closeDialog) {
            this.props.closeDialog();
            return true;
        }
        return false;
    };
    static displayName = "DialogLayout";
}
